import { RecruitmentActivityType } from '../../../../../../../shared/types/recruitmentTypes';
import { ComplexTooltip } from '../../../../../../../shared/frontend/components/presentational/tooltip';
import WowIcon from '../../../../../../../shared/frontend/scripts/wow/components/WowIcon';
import { t } from 'i18next';

type TActivityInfoType = {
  icon: string;
  title: string;
};

// exported for use in raidContextBar  (via menuItems.ts)
export const ACTIVITY_INFO_FOR_TYPE: { [key: string]: TActivityInfoType } = {
  [RecruitmentActivityType.GuildRaids]: {
    icon: 'achievement_raid_torghastraid',
    title: `recruitment:activity.${RecruitmentActivityType.GuildRaids}`
  },
  [RecruitmentActivityType.GuildSocial]: {
    icon: 'inv_7xp_inscription_talenttome01',
    title: `recruitment:activity.${RecruitmentActivityType.GuildSocial}`
  },
  [RecruitmentActivityType.TeamMythicPlus]: {
    icon: 'achievement_dungeon_gloryofthehero',
    title: `recruitment:activity.${RecruitmentActivityType.TeamMythicPlus}`
  },
  [RecruitmentActivityType.GuildMythicPlus]: {
    icon: 'achievement_dungeon_gloryoftheraider',
    title: `recruitment:activity.${RecruitmentActivityType.GuildMythicPlus}`
  },
  [RecruitmentActivityType.GuildPvp]: {
    icon: 'achievement_arena_2v2_7',
    title: `recruitment:activity.${RecruitmentActivityType.GuildPvp}`
  }
};

type TRecruitmentActivityIconProps = {
  type: string;
  size: 'xx-small' | 'x-small' | 'small' | 'medium' | 'large';
  className?: string;
  hideTooltip?: boolean;
};

export function getRecruitmentActivityTypeInfo(activityType: string) {
  return (
    ACTIVITY_INFO_FOR_TYPE[activityType] || {
      icon: 'inv_misc_questionmark',
      title: activityType.toUpperCase()
    }
  );
}

export function RecruitmentActivityIcon(props: TRecruitmentActivityIconProps) {
  const icon = <WowIcon size={props.size} icon={ACTIVITY_INFO_FOR_TYPE[props.type].icon} className={props.className} />;

  if (props.hideTooltip) {
    return icon;
  } else {
    return (
      <ComplexTooltip tag="span" placement="top" tooltip={t(ACTIVITY_INFO_FOR_TYPE[props.type].title)}>
        {icon}
      </ComplexTooltip>
    );
  }
}
